import { Container } from '@mui/material';
import React, { useState } from 'react';
import Colors from '../../colors';
import MultilineInput from '../MultilineInput';
import PhoneTextInput from '../PhoneTextInput';
import OutlineButton from './Buttons/outline/OutlinedModalButton';
import ConfirmationModal from './ConfirmationModal';
import ModalContainer from './ModalContainer';
import { styled } from '@mui/material/styles';
import {NOTES} from '../../constants'
function MemberInfoModal(props) {
    const { isVisible, setIsVisible,
        firstName, lastName,
        checkinTime, checkoutTime,
        phoneNumber, notes, equipment,
        onClick, deleteMemberHandler, isArchived } = props;

    const [phoneNumberText, setPhoneNumberText] = useState(phoneNumber);
    const [equipmentText, setEquipmentText] = useState(equipment);
    const [notesText, setExtraNotesText] = useState(notes);
    const [isdelete, setDelete] = useState(false);

    const ButtonContainer = styled('div')({
        display: 'flex',
        flexDirection: 'column',
        gap: '15px',
        alignContent: 'center',
    });

    const handleMainAction = () => {
        onClick(phoneNumberText, equipmentText, notesText);
        setIsVisible(false);
    }
    const handledelete = () => {
        setDelete(true)
    }
    return (
        <ModalContainer
            isVisible={isVisible}
            setIsVisible={setIsVisible}
            title={`${firstName} ${lastName}`} >
            <Container>
                {/* Check In */}
                <div style={{ marginBottom: '10px' }}>
                    <label style={{
                        fontFamily: 'Jost',
                        fontWeight: 600,
                        color: 'var(--dark-gray)',
                        textTransform: 'capitalize',
                        marginBottom: 0
                    }}>
                        {'Check In'}
                    </label>
                    <p style={{ marginTop: 0 }}>{checkinTime ? checkinTime : 'Not Checked In'}</p>
                </div>

                {/* Check Out */}
                <div style={{ marginBottom: '10px' }}>
                    <label style={{
                        fontFamily: 'Jost',
                        fontWeight: 600,
                        color: 'var(--dark-gray)',
                        textTransform: 'capitalize',
                    }}>
                        {'Check Out'}
                    </label>
                    <p style={{ marginTop: 0 }}>{checkoutTime ? checkoutTime : 'Not Checked Out'}</p>
                </div>

                {/* Phone Number */}
                <PhoneTextInput
                    label={'Phone Number (Optional)'}
                    phoneNumberText={phoneNumberText}
                    setPhoneNumberText={setPhoneNumberText}
                    disabled = {isArchived} />

                {/* Equipment */}
                <MultilineInput
                    label={'Equipment'}
                    placeholder={'Enter the name of the equipment loaned'}
                    maxChars={250}
                    value={equipmentText}
                    setText={setEquipmentText} 
                    disabled = {isArchived}/>

                {/* Extra Notes */}
                <MultilineInput
                    label={'Notes (optional)'}
                    placeholder={NOTES}
                    maxChars={250}
                    value={notesText}
                    setText={setExtraNotesText}
                    disabled = {isArchived} />
            </Container>
            {!isArchived && <ButtonContainer>
                <OutlineButton color={Colors.green} onClick={handleMainAction} label={"Save"}></OutlineButton>
                <OutlineButton color={Colors.red} onClick={handledelete} label={"Delete"}></OutlineButton>
            </ButtonContainer>}
            {isdelete && <ConfirmationModal
                title={"Do you want to permanently delete this member?"}
                mainAction={"Yes"}
                isVisible={isdelete}
                setIsVisible={setDelete}
                mainActionHandler={deleteMemberHandler}
                color={Colors.green} />}
        </ModalContainer>

    );
}

export default MemberInfoModal;